module.exports = __webpack_public_path__ + "resources/img/img_codesign2_m.a1c774355de4714091b01f0cfe3ee160.png";